class SizeSelector extends HTMLElement {
  constructor() {
    super();

    this.inputs = document.querySelectorAll(".size__selector input[type='radio']");
    this.inputs.forEach(element => {
      element.addEventListener('click', e => {
        this.onSelected(element, e);
      });
    });
  }

  onSelected(element, e) {
    // Uncheck any previous
    document.querySelector('.size__choice[data-checked="true"]').dataset.checked = false;
    // Check the label
    element.closest('.size__choice').dataset.checked = true;

    // Check if product form exists and update it if it does
    let inputQuantity = document.querySelector('.product-form input[name="quantity"]');
    if (inputQuantity) {
      inputQuantity.value = element.closest('.size__choice').dataset.value;
    }
  }

}

customElements.define('size-selector', SizeSelector);
